import { useMemo } from 'react';
import { useFeatureFlag } from './useFeatureFlag';
export const useMenuProps = ({ label }: { label: string }) => {
  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');
  const menuProps = useMemo(
    () => ({ MenuListProps: { 'aria-label': label } }),
    [label]
  );
  if (isTiwScreenReaderEnabled) {
    return menuProps;
  }
  return undefined;
};
